import React, { useContext } from 'react';
import {
  MenuGroup,
  MenuGroupLabel,
} from 'structure/Layouts/LayoutWithSideBar/desktop/MenuGroup';
import { MenuItem } from 'structure/Layouts/LayoutWithSideBar/desktop/MenuItem';
import { MenuItemIcon } from 'structure/Layouts/LayoutWithSideBar/desktop/MenuItemIcon';
import { cx } from 'class-variance-authority';
import { DesktopLayoutContext } from 'structure/Layouts/LayoutWithSideBar/desktop/DesktopLayoutContext';
// import { MenuSubItem } from 'structure/Layouts/LayoutWithSideBar/desktop/MenuSubItem';
import { hasActive, isActive } from 'structure/Layouts/LayoutWithSideBar/menu';
import { useTranslation } from 'react-i18next';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { twMerge } from 'tailwind-merge';
import { usePathname } from 'next/navigation';
import { buildMenuDappDesktop } from 'structure/Layouts/LayoutWithSideBar/menuDapp';
import { appConfig } from 'utils/app.config';

type SidebarProps = {
  className?: string;
  style?: React.CSSProperties;
  isBannerClosed?: boolean;
};

export const SideBar = ({
  className,
  style = {},
  isBannerClosed,
}: SidebarProps) => {
  const pathname = usePathname();
  const { t } = useTranslation('common');
  const sideBarMenu = buildMenuDappDesktop(t);
  const desktopLayoutContext = useContext(DesktopLayoutContext);
  const { sideBarExpanded, setSideBarExpanded } = desktopLayoutContext;

  const handleClickExpand = () => {
    setSideBarExpanded(!sideBarExpanded);
  };

  return (
    <div
      style={style}
      className={twMerge(
        cx(
          `fixed left-0 ${!appConfig.featureFlags.ENABLE_BANNER || isBannerClosed ? 'top-24 h-[calc(100vh-6rem)] pt-1' : 'top-[8rem] h-[calc(100vh-8rem)] pt-4'} z-10 flex flex-col pb-7 pl-7 ${sideBarExpanded && 'bg-black-800'} border-r border-customBorder pr-6 max-lg:hidden`,
          className
        )
      )}
    >
      <nav className='flex flex-grow flex-col'>
        {sideBarMenu.map((group, index) => (
          <MenuGroup key={(group.label ?? '') + index}>
            {group.label && <MenuGroupLabel>{group.label}</MenuGroupLabel>}
            {group.items.map((item) => (
              <MenuItem
                key={item.label + '_' + item.icon}
                label={sideBarExpanded ? item.label : ''}
                href={item.href}
                target={item.target}
                icon={
                  <MenuItemIcon
                    active={
                      item.href !== '/' &&
                      ((item.href && isActive(item, pathname)) ||
                        (item.items && hasActive(item.items, pathname)))
                    }
                    icon={item.icon!}
                  />
                }
              >
                {/* {item.items?.map((subItem) => (
                  <MenuSubItem
                    active={isActive(subItem, pathname)}
                    key={subItem.label}
                    label={subItem.label}
                    href={subItem.href}
                    onClick={handleClickExpand}
                  />
                ))} */}
              </MenuItem>
            ))}
          </MenuGroup>
        ))}
        <div className='mt-auto pt-10' onClick={handleClickExpand}>
          <MenuItem
            label='Close Menu'
            icon={
              <div
                className={cx(
                  'rounded-full border border-white-600 p-2',
                  'transition-all duration-500 ease-in-out',
                  desktopLayoutContext.sideBarExpanded
                    ? '-rotate-90'
                    : 'rotate-90'
                )}
              >
                <Icon
                  icon='expand_less'
                  width={22}
                  height={22}
                  color={'#B4BCD0'}
                />
              </div>
            }
          />
        </div>
      </nav>
    </div>
  );
};
